
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"43","height":"35","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M10.857 19.688H6.45a6.394 6.394 0 01-4.56-1.923A6.621 6.621 0 010 13.125c0-1.74.68-3.41 1.89-4.64a6.394 6.394 0 014.56-1.922c.04 0 .074.013.107.013C7.075 2.864 10.187 0 13.976 0a7.41 7.41 0 014.275 1.367 7.613 7.613 0 012.746 3.603 6.296 6.296 0 012.654-.595c1.71 0 3.351.691 4.56 1.922a6.621 6.621 0 011.89 4.64 6.455 6.455 0 01-.47 2.373 7.344 7.344 0 00-2.123.806 9.585 9.585 0 00-3.212-2.35 9.438 9.438 0 00-3.87-.829c-4.965 0-9.023 3.842-9.568 8.75z","fill":"#0067AD"}}),_c('path',{attrs:{"d":"M43 28.438c0 1.74-.68 3.41-1.89 4.64A6.394 6.394 0 0136.55 35h-21.5a6.394 6.394 0 01-4.56-1.922 6.621 6.621 0 01-1.89-4.64 6.53 6.53 0 014.441-6.207 7.908 7.908 0 01-.141-1.45c0-1.005.194-2.001.572-2.93a7.66 7.66 0 011.63-2.485 7.513 7.513 0 012.443-1.66 7.41 7.41 0 012.88-.581c2.902 0 5.402 1.702 6.652 4.156.987-1.196 2.445-1.968 4.098-1.968 1.426 0 2.793.576 3.8 1.601a5.518 5.518 0 011.575 3.867c.002.372-.034.743-.107 1.108.033 0 .067-.014.107-.014 1.71 0 3.351.691 4.56 1.922a6.621 6.621 0 011.89 4.64z","fill":"#B0B7C3"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h43v35H0z"}})])])])
          )
        }
      }
    